import styled, { css } from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import {
  desktopImageHeight,
  desktopImageLeftOffset,
  desktopImageWidth,
} from '../TestimonialImage/styles';

export const testimonialAnimationTime = 800; // This must be kept consistent with testimonialAnimationTime in TestimonialWithImage\style.ts

export const ExpandableQuoteContainer = styled.div`
  position: relative;
  background-color: ${colors.core01};
  overflow: hidden;

  ${mediaQuery.desktop`
    height: ${desktopImageHeight};
    padding-left: calc(${desktopImageWidth} - ${desktopImageLeftOffset});
  `}
`;

const QuoteCommonStyle = css`
  ${mediaQuery.desktop`
    height: 100%;
    display: flex;
    align-items: center;
  `}
`;

export const CurrentQuote = styled.div`
  ${QuoteCommonStyle};
`;

export const OldQuote = styled.div`
  position: absolute;
  opacity: 0;
  visibility: hidden;
  top: 0;

  ${QuoteCommonStyle};
`;

export const QuoteContainer = styled.div`
  padding: ${spacing(5)} ${spacing(2)};

  ${mediaQuery.tabletPortrait`
    padding: ${spacing(7)} ${spacing(3)};
  `}

  ${mediaQuery.desktop`
    padding: ${spacing(7)} ${spacing(5)} ${spacing(7)} ${spacing(8)};
  `}
`;

const QuotationMarkStyle = css`
  font-size: 1.5rem;
  line-height: 2rem;
`;

export const Quote = styled.p`
  ${fonts.paragraph}
  font-weight: 500;
  color: ${colors.neutral08};
  margin: 0;

  &::before {
    content: '\u201C';
    ${QuotationMarkStyle}
  }

  &::after {
    content: '\u201D';
    ${QuotationMarkStyle}
  }
`;

export const Author = styled.div`
  margin: ${spacing(3)} 0 0 0;
  ${fonts.paragraphSmall};
  color: ${colors.neutral08};
`;

export const AuthorJobDescription = styled.span`
  color: ${colors.core03};
`;
